
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import PersonenDetail from '@/components/Personen/PersonenDetail.vue';
    import Person from '@/types/Person';
    import { LoadPersonenPayload, PersonenFilter } from '@/store/personen';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            PersonenDetail,
        },
        computed: {
            ...mapState('personen', ['personen', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('personen', ['loadPersonen']),
            ...mapMutations('personen', ['setDialogsDetail']),
        },
    })
    export default class Personen extends Vue {
        public loadPersonen!: (payload?: LoadPersonenPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public person = new Person();
        public search = '';

        public filter: PersonenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Person> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Name', value: 'arzt' },
                { text: 'Titel', value: 'titel' },
                { text: 'Vorname', value: 'vorname' },
                { text: 'Nachname', value: 'nachname' },
                { text: 'Personalzahl', value: 'personalzahl' },
                { text: 'Arzt Nr.', value: 'arztnr' },
                { text: 'Rolle', value: 'rolle' },
                /*{ text: 'Impfstelle', value: 'impfstelle_bezeichnung' },*/
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadPersonen();
        }

        public onChangeFilter(): void {
            this.loadPersonen({ filter: this.filter });
        }

        public onClickEdit(person: Person): void {
            this.person = { ...person };
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.person = new Person();
            this.setDialogsDetail(true);
        }
    }
